<template>
  <main>
    <div class="box">
      <header>
        <h3>{{ info.QTitle }}</h3>
      </header>
      <div class="cont" v-html="info.AText"></div>
    </div>
  </main>
</template>

<script>
import $visa from '@api/visa';
export default {
  data () {
    return {
      info: {}
    }
  },
  created () {
    const { id } = this.$route.query;
    if ( !id ) { this.$router.push({ name: 'faq' }); return; }
    $visa.getFaqDetail(id).then(res => {
      const [ info ] = res;
      this.info = info;
    })
  },
  methods: {
  }
}
</script>

<style scoped src="./faq.css"></style>